export const  colors = [
    {
      row: 1,
      subColors: [
        {
          colorValue: '#030303',
          selected: false,
        },
        {
          colorValue: '#5A5A5B',
          selected: false,
        },
        {
          colorValue: '#AFAFB1',
          selected: false,
        },
        {
          colorValue: '#FFFFFF',
          selected: false,
        },
      ],
    },
    {
      row: 2,
      subColors: [
        {
          colorValue: '#A0961F',
          selected: false,
        },
        {
          colorValue: '#266D9A',
          selected: false,
        },
        {
          colorValue: '#236834',
          selected: false,
        },
        {
          colorValue: '#8B1417',
          selected: false,
        },
      ],
    },
    {
      row: 3,
      subColors: [
        {
          colorValue: '#FCEE31',
          selected: false,
        },
        {
          colorValue: '#3AA6ED',
          selected: false,
        },
        {
          colorValue: '#4BAC49',
          selected: false,
        },
        {
          colorValue: '#E35E2B',
          selected: false,
        },
      ],
    },
  ];